import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'

export interface ArenaFilters {
  page: number
  limit: number
  search: string
  orderBy: string
}

interface ArenaFilterProps {
  filters: ArenaFilters
  onFiltersChange: (filters: Partial<ArenaFilters>) => void
  onAddClick: () => void
}

export default function ArenaFilter({
  filters,
  onFiltersChange,
  onAddClick,
}: ArenaFilterProps) {
  const handleSearchChange = (value: string) => {
    onFiltersChange({ search: value, page: 1 })
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">
              จัดการสนามแข่งขัน
            </h2>
            <Button onClick={onAddClick}>เพิ่มสนามแข่งขัน</Button>
          </div>

          <Separator className="border-gray-200" />

          <div className="flex gap-6 flex-wrap">
            {/* Search */}
            <div className="space-y-1 min-w-[260px]">
              <p className="text-sm font-medium text-gray-500 mb-1">ค้นหา</p>
              <Input
                value={filters.search}
                onChange={(e) => handleSearchChange(e.target.value)}
                placeholder="พิมพ์ชื่อ คำอธิบาย หรือเบอร์โทร"
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
